<template>
  <div>
    <div class="msg">{{ answerReport }}</div>
    <div class="group">
      <div class="list" v-for="(item, index) in wordArr" :key="'list' + index">
        <div
          class="letter"
          :class="{
            'is-normal': letter.status === 'is-normal',
            'is-active': letter.status === 'is-active',
            'is-right': letter.status === 'is-right',
            'is-wrong': letter.status === 'is-wrong',
          }"
          :key="'letter' + letterIndex"
          v-for="(letter, letterIndex) in item"
        >
          <div v-html="letter.word"></div>
          <div class="now-key" v-if="letter.status === 'is-wrong'">
            {{ letter.nowKey }}
          </div>
        </div>
      </div>
    </div>
    <successDialog
      v-if="showDialog"
      @clickConfirm="clickConfirm"
      @clickClose="clickClose"
      :is-confirm-dialog="true"
      :dialog-title="'Congratulations'"
      :dialog-img="dialogImg"
    >
    </successDialog>
  </div>
</template>

<script>
import dialog from "../views/mixins/dialog";
export default {
  props: {
    listWordData: {
      type: String,
    },
    dialogImg: {
      type: String,
      default: "",
    },
  },
  watch: {
    listWordData: {
      handler(value) {
        // debugger
        this.nowIndex = 0;
        this.wordArr = [];
        // this.wrongNum = 0;
        for (let index = 0; index < value.length; index++) {
          let element = value.slice(index, index + 1);
          let obj = {
            word: element,
            status: index === 0 ? "is-active" : "is-normal",
          };
          this.wordArr.push(obj);
        }
        console.log(this.wordArr);
        this.maxIndex = this.wordArr.length;
        this.wordArr = this.arrTrans(this.wordArr, this.size);
      },
      deep: true,
      immediate: true,
    },
    $route() {
      this.answerReport = "";
    },
  },
  mixins: [dialog],
  data() {
    return {
      wordArr: [],
      size: 36,
      nowIndex: 0,
      maxIndex: 0,
      answerReport: "",
      goBackNum: 0,
      goBackMaxNum: 100,
      wrongNum: 0,
    };
  },
  methods: {
    arrTrans(arr, size) {
      // 一维数组转换为二维数组
      let result = [];
      for (let x = 0; x < Math.ceil(arr.length / size); x++) {
        let start = x * size;
        let end = start + size;
        result.push(arr.slice(start, end));
      }
      return result;
    },
    updateWrongNum() {
      this.wrongNum = 0;
      this.wordArr.forEach((item) => {
        item.forEach((obj) => {
          if (obj.status === "is-wrong") {
            this.wrongNum++;
          }
        });
      });
    },
    handlerWord(key) {
      let keyActiveObj =
        this.wordArr[parseInt(this.nowIndex / this.size)][
          this.nowIndex % this.size
        ];
      this.$set(keyActiveObj, "nowKey", key);
      if (key === "{bksp}") {
        this.goBackNum++;
        if (this.goBackNum > this.goBackMaxNum) {
          console.log("只有10次改错机会哦");
          return false;
        }
        this.$set(keyActiveObj, "status", "is-normal");
        if (this.nowIndex !== 0) {
          this.nowIndex--;
        }
        let nextKeyActiveObj =
          this.wordArr[parseInt(this.nowIndex / this.size)][
            this.nowIndex % this.size
          ];
        this.$set(nextKeyActiveObj, "status", "is-active");
        this.updateWrongNum();
        return false;
      }
      if (this.wrongNum > 0) {
        console.log("wrongNum", this.wrongNum);
        return false;
      }
      if (key === keyActiveObj.word) {
        this.$set(keyActiveObj, "status", "is-right");
      } else {
        this.$set(keyActiveObj, "status", "is-wrong");
        // this.wrongNum ++
        // console.log('wrongNum22',this.wrongNum)
      }
      if (this.nowIndex === this.maxIndex - 1) {
        let correctNum = 0;
        this.wordArr.forEach((item) => {
          item.forEach((obj) => {
            if (obj.status === "is-right") {
              correctNum++;
            }
          });
        });
        this.answerReport =
          "总共" +
          this.maxIndex +
          "字符，答对" +
          correctNum +
          "个，正确率为" +
          parseInt((correctNum / this.maxIndex) * 100) +
          "%";
        this.showDialog = true;
        this.updateWrongNum();
        return false;
      }
      this.nowIndex++;
      let nextKeyActiveObj =
        this.wordArr[parseInt(this.nowIndex / this.size)][
          this.nowIndex % this.size
        ];
      this.$set(nextKeyActiveObj, "status", "is-active");
      this.updateWrongNum();
    },
    nextWord() {
      return this.listWordData[this.nowIndex];
    },
    nextKey() {
      return this.listWordData[this.nowIndex];
    },
  },
};
</script>

<style scoped>
.msg {
  text-align: center;
}
.group {
  margin: auto;
  width: 800px;
  background: #fff;
  border-radius: 10px;
}
.list {
  display: flex;
  margin-left: 17px;
  border-bottom: 2px solid #ccc;
}
.letter {
  font-family: pt-mono, "Courier New", Courier, "Lucida Sans Typewriter",
    "Lucida Typewriter", monospace;
  font-weight: 500;
  border-bottom: 3px solid transparent;
  color: #4a4a4a;
  display: inline-block;
  line-height: 1.5;
  margin: 5px 2px 5px 0;
  min-width: 19px;
  border-radius: 5px;
  text-align: center;
  font-size: 30px;
  position: relative;
  overflow: visible;
}
.letter:last-child {
  margin-right: 0;
}
.is-normal {
  background-color: transparent;
  color: #4a4a4a;
}
.is-active {
  background-color: transparent;
  color: #3295db;
  border-color: #3295db;
  border-radius: 0;
  animation-name: breathe;
  animation-duration: 2700ms;
  animation-iteration-count: infinite;
}
@-webkit-keyframes breathe {
  0% {
    border-color: #3295db;
  }
  50% {
    border-color: transparent;
  }
  100% {
    border-color: #3295db;
  }
}
.letter.is-right {
  background: #edf7e7;
  color: #95c590;
  transition: color 0.12s ease-in-out;
}
.is-wrong {
  background-color: #ffdcd9;
  color: #d55b60;
  animation-name: shock;
  animation-duration: 0.7s;
}
@keyframes shock {
  0%,
  100% {
    transform: translateX(0);
  }
  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translateX(-3px);
  }
  20%,
  40%,
  60%,
  80% {
    transform: translateX(3px);
  }
}
.now-key {
  position: absolute;
  background-color: transparent;
  color: red;
  animation-name: cursorBlink;
  animation-delay: 0.1s;
  top: 20px;
  opacity: 0;
  animation-duration: 0.8s;
  width: 100%;
  height: 100%;
}
@keyframes cursorBlink {
  0% {
    transform: rotate(0deg);
    top: 20px;
    opacity: 0.5;
  }
  25% {
    transform: rotate(-20deg);
    top: 25px;
    opacity: 0.8;
  }
  50% {
    transform: rotate(0deg);
    top: 30px;
    opacity: 0.8;
  }
  75% {
    transform: rotate(20deg);
    top: 35px;
    opacity: 0.8;
  }
  100% {
    transform: rotate(0deg);
    top: 40px;
    opacity: 0.8;
  }
}
</style>
